module.exports = __webpack_public_path__ + "media/images/logos/i-site-c72ffd00a519e8fe8176f32a14a57205.jpg";